import axios from '../utils/axios'
import { getStaticConfigs } from "../helpers/common";

export async function getNotifications(payload: any)
{

      const staticConfigs = await getStaticConfigs();

      const _url = staticConfigs?.REACT_APP_API_BASE_URL_CBD;
      return axios.get(`${_url}/api/v1/notifications`, payload);
}
